export default __webpack_public_path__ + "9faef3e711ef6c75194254ee280e0f14.svg";